/**
 * Geld ist im ganzen Haus ein Integer in Cent. Hier wird NUR formatiert und
 * gelesen - nie gerechnet.
 *
 * ⚠️ Eine Zwischensumme im Browser wäre die zweite Wahrheit, die als Erstes
 * falsch wird: der Server liefert Saldo und Verbrauch fertig, die Oberfläche
 * zeigt sie an.
 */
const FORMAT = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' })

export function centsFormatiert(cents: number, waehrung = 'EUR'): string {
  const wert = cents / 100
  return waehrung === 'EUR'
    ? FORMAT.format(wert)
    : new Intl.NumberFormat('de-DE', { style: 'currency', currency: waehrung }).format(wert)
}

/**
 * Mit ausgeschriebenem Vorzeichen - für Zeilen in einem Auszug.
 *
 * ⚠️ Das Vorzeichen steht DA, nicht nur die Farbe. Wer Rot und Grün nicht
 * unterscheidet, sieht sonst zwei gleiche Zahlen; und eine Kontobewegung, bei
 * der man raten muss, in welche Richtung sie ging, ist keine.
 */
export function centsMitVorzeichen(cents: number, waehrung = 'EUR'): string {
  const zeichen = cents < 0 ? '−' : '+'
  return `${zeichen}${centsFormatiert(Math.abs(cents), waehrung)}`
}

/**
 * Liest eine Eingabe wie „5,50", „5.5", „-3" oder „1 234,05" als Cent.
 *
 * ⚠️ Bewusst über die ZEICHENKETTE, nicht über `parseFloat(x) * 100`. Der
 * naheliegende Weg ist der klassische Geldfehler: `parseFloat('8.20') * 100`
 * ergibt 819.9999999999999, und `Math.round` rettet nur solange, bis jemand
 * eine dritte Nachkommastelle tippt.
 *
 * `null` heißt „keine gültige Eingabe" - nicht „0". Eine 0 wäre ein Betrag,
 * den niemand gemeint hat.
 */
export function centsAusEingabe(text: string): number | null {
  const sauber = text.trim().replace(/\s/g, '').replace(',', '.')
  const treffer = /^(-)?(\d*)(?:\.(\d{1,2}))?$/.exec(sauber)
  if (!treffer) return null
  const [, minus, ganze = '', nachkomma] = treffer
  if (ganze === '' && nachkomma === undefined) return null
  const euro = ganze === '' ? 0 : Number(ganze)
  const cent = nachkomma === undefined ? 0 : Number(nachkomma.padEnd(2, '0'))
  if (!Number.isSafeInteger(euro) || !Number.isSafeInteger(cent)) return null
  const betrag = euro * 100 + cent
  return minus ? -betrag : betrag
}

/** Anteil eines Budgets, auf 0…1 geklemmt - nur für die Breite des Balkens. */
export function balkenAnteil(verbraucht: number, grenze: number): number {
  if (grenze <= 0) return 0
  return Math.min(1, Math.max(0, verbraucht / grenze))
}
